import React from 'react';
import { toast } from 'react-toastify';
import { ToastNature } from '../../common/types';
import ToastContent from './toastContent';

interface ToastProps {
  description: string;
  nature: ToastNature;
}

const Toast = {
  
  description: '',

  notify({ description, nature }: ToastProps) {

      // to avoid duplicate toasts
      if (this.description === description) {
        return this;
      }

      // Create single instance of Toast
        switch (nature) {
            case ToastNature.ERROR:
                toast.error(
                <ToastContent description={description} nature={nature} />,
                {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );
              break;
            case ToastNature.WARNING:
              toast.warning(
                <ToastContent description={description} nature={nature} />,
                {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );
              break;
            case ToastNature.SUCCESS:
                toast.success(
                <ToastContent description={description} nature={nature} />,
                {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 2000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                }
              );
              break;
          }

      this.description = description;
      
      setTimeout(() => {
        this.description = '';
      }, 3000);

    return this;
  },
};

export default Toast;

